import styled from '@emotion/styled'
import { Hero } from 'app/components/Hero'
import { Intro } from 'app/components/Intro'
import { OffersSlider } from 'app/components/OffersSlider'
import { QuickInfo } from 'app/components/QuickInfo'
import { RoomsList } from 'app/components/RoomsList'
import { SEO } from 'app/components/SEO'
import { Footer } from 'app/containers/Footer'
import { GoogleAnalytics } from 'app/containers/GoogleAnalytics'
import { Hashtag } from 'app/containers/Hashtag'
import { Header, Props as HeaderProps } from 'app/containers/Header'
import { StructuredData } from 'app/containers/StructuredData'
import { PageProps } from 'gatsby'
import React, { memo } from 'react'

import { Props } from './contents'

export interface PageContext {
  id?: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
}

export interface Context extends PageContext {
  props: Props
}

export default memo(function RoomsPageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  return (
    <Container>
      <SEO {...context.seoProps} />
      <GoogleAnalytics />
      {pageContext.headerProps ? (
        <Header
          pageID={pageContext.id}
          languageCode={pageContext.languageCode}
          languagePrefix={pageContext.languagePrefix}
          {...pageContext.headerProps}
        />
      ) : null}
      {context.heroProps ? <Hero {...context.heroProps} /> : null}
      {context.introProps ? <Intro {...context.introProps} /> : null}
      {context.quickInfoProps ? (
        <QuickInfo {...context.quickInfoProps} />
      ) : null}
      {context.roomsListProps ? (
        <RoomsList {...context.roomsListProps} />
      ) : null}
      {context.offersSliderProps ? (
        <OffersSlider variant="compact" {...context.offersSliderProps} />
      ) : null}
      <Hashtag />
      <Footer
        languageCode={pageContext.languageCode}
        languagePrefix={pageContext.languagePrefix || 'it'}
      />
      <StructuredData languageCode={pageContext.languageCode} />
    </Container>
  )
})

const Container = styled.main``
